<template>
  <div>
  <CRow>
    <CCol><h3>Edit user</h3></CCol>
    <CCol>
        <router-link to="/users">
    <CButton color="primary" class="float-right">
          Back to user list
        </CButton></router-link>
        </CCol>
  </CRow>
    <CAlert :color="alert.color" closeButton :show.sync="alert.show">
      {{ alert.text }}
    </CAlert>
    <CCard>
      <CCardBody>
        <CNav variant="pills">
          <div @click="showUserModal()">
            <CNavItem active>Edit User</CNavItem>
          </div>
          <div @click="showPasswordModal()">
            <CNavItem>Reset Password</CNavItem>
          </div>
          <div @click="showUserObjectModal()">
            <CNavItem>Raw Object</CNavItem>
          </div>
        </CNav>

        <div v-if="active === 'user'">
          <CRow class="mt-3">
            <CCol>
              <CCardTitle>User Details</CCardTitle>
            </CCol>
            <CCol>
              <CButton
                class="float-right"
                color="primary"
                variant="outline"
                square
                @click="deleteConnfirmation"
              >
                Delete User</CButton
              >
            </CCol>
          </CRow>
          <CRow alignVertical="center">
            <CCol sm="7">
              <CRow>
                <CCol>
                  <CInput
                    label="Name"
                    placeholder="Enter your name"
                    v-model="user.name"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <CInput
                    label="Email Address"
                    placeholder="Enter your email address"
                    v-model="user.email"
                  />
                </CCol>
              </CRow>
              <CRow v-if="user && user.app_metadata">
                <CCol>
                  <CInput
                    label="Organization"
                    placeholder="Organization"
                    v-model="user.app_metadata.organization"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <CInput
                    type="password"
                    label="Password"
                    placeholder="Enter Password"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <CInput
                    type="password"
                    label="Confirm Password"
                    placeholder="Enter Confirm Password"
                  />
                </CCol>
              </CRow>
              <h5 class="mt-3">Account Type</h5>
              <CRow class="my-3" v-if="user && user.app_metadata">
                <CCol sm="8">
                  <CInputCheckbox
                    label="Trial User"
                    :checked.sync="user.app_metadata.trial_user"
                  ></CInputCheckbox>
                </CCol>
              </CRow>
              <CRow
                v-if="user && user.app_metadata && user.app_metadata.trial_user"
              >
                <CCol sm="8">
                  <div width="100%">
                    <datetime
                      type="date"
                      v-model="user.app_metadata.trial_expiry"
                    >
                      <label for="startDate" slot="before"
                        >Trial Expiry:
                      </label>
                      <span class="description" slot="after"
                        ><br /><i>Expiry for trial account</i></span
                      >
                    </datetime>
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol v-if="userAssignedRole.length">
                  <h5 class="mt-3">Roles</h5>
                  <CRow
                    v-for="(role, index) in userAssignedRole"
                    :key="role.id"
                    class="my-3"
                  >
                    <CCol sm="8">{{ role.name }}</CCol>
                    <CCol sm="4" v-if="!loading.deleteRole[index]">
                      <a @click="removeUserRole(role.id, index)">
                        <CIcon name="cilXCircle" class="pointer" />
                      </a>
                    </CCol>
                    <CCol v-else>
                      <CSpinner size="sm" color="info"></CSpinner>
                    </CCol>
                  </CRow>
                </CCol>
                <CCol v-else>
                  <CSpinner
                    size="sm"
                    color="info"
                    v-if="loading.fetchRole"
                  ></CSpinner>
                  <strong v-else class="text-danger">No role found !</strong>
                </CCol>
              </CRow>
              <CRow
                v-for="number in addNumberOfRole"
                :key="number"
                alignVertical="center"
              >
                <CCol sm="7">
                  <CSelect
                    label="Roles"
                    :options="roles"
                    :value.sync="userSelectedRole[number - 1]"
                  ></CSelect>
                </CCol>
                <CCol sm="5" class="pt-3">
                  <CButton
                    v-if="!loading.addRole[number - 1]"
                    color="info"
                    variant="outline"
                    square
                    size="sm"
                    :disabled="!userSelectedRole[number - 1]"
                    @click="setRoles(number)"
                  >
                    Add role
                  </CButton>
                  <CSpinner color="info" size="sm" v-else></CSpinner>
                </CCol>
              </CRow>
              <CRow v-if="alertForAddRole.show">
                <CCol>
                  <CAlert
                    :color="alertForAddRole.color"
                    closeButton
                    :show.sync="alertForAddRole.show"
                  >
                    {{ alertForAddRole.text }}
                  </CAlert>
                </CCol>
              </CRow>
              <CRow class="py-3">
                <CCol sm="8">
                  <a class="pointer" @click="addRoleCount()"
                    ><u>Click to add another role.</u></a
                  >
                </CCol>
              </CRow>
              <CRow>
                <CCol v-if="!loading.userUpdate">
                  <CButton
                    color="info"
                    variant="outline"
                    square
                    @click="editConfirmation()"
                  >
                    Save Changes
                  </CButton>
                </CCol>
                <CCol v-else>
                  <CSpinner color="info"></CSpinner>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </div>
        <CRow v-if="active === 'password'">
          <CCol sm="5" class="mt-3  ">
            <CCard>
              <CCardBody>
                <CCardTitle>Reset Password</CCardTitle>
                <CRow>
                  <CCol>
                    <CInput
                      type="text"
                      label="New Password"
                      placeholder="Enter Password"
                      v-model="newPassword"
                      :isValid="isPasswordValid(newPassword)"
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol>
                    <CInput
                      type="text"
                      label="Confirm Password"
                      placeholder="Enter Confirm Password"
                      v-model="confirmNewPassword"
                      :isValid="isConfirmNewPasswordMatch(confirmNewPassword)"
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol v-if="!loading.newPassword">
                    <CButton
                      color="info"
                      variant="outline"
                      square
                      @click="resetPasswordConfirmation"
                      :disabled="
                        !isPasswordValid(newPassword) ||
                          !isConfirmNewPasswordMatch(confirmNewPassword)
                      "
                    >
                      Reset Password
                    </CButton>
                  </CCol>
                  <CCol v-else>
                    <CSpinner size="sm" color="info" />
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>

        <CRow v-if="active === 'raw'" class="ml-3 mr-3 mt-3 mb-3  ">
          <pre>{{ user }}</pre>
        </CRow>
      </CCardBody>
    </CCard>
    <TheModal
      :color="showModal.color"
      :size="showModal.size"
      :title="showModal.title"
      :showModal="showModal.show"
      :text="showModal.text"
      @cancel="showModal.show = false"
      @okay="okay($event)"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TheModal from "./../containers/TheModal";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import moment from "moment";

export default {
  name: "EditUser",
  data() {
    return {
      user: {},
      active: "user",
      userAssignedRole: [],
      showModal: {
        type: "",
        color: "",
        size: "",
        show: false,
        text: "",
        title: ""
      },
      newPassword: "",
      confirmNewPassword: "",
      loading: {
        newPassword: false,
        userUpdate: false,
        deleteRole: [],
        fetchRole: false,
        addRole: []
      },
      userSelectedRole: [null],
      alert: {
        show: false,
        text: "",
        color: ""
      },
      alertForAddRole: {
        show: false,
        color: "",
        text: ""
      },
      addNumberOfRole: 1,
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715"
      }
    };
  },
  components: {
    TheModal,
    Datetime
  },
  async mounted() {
    if (this.$route.params.user) {
      this.user = this.$route.params.user;
      if (!this.user.app_metadata) {
        this.user.app_metadata = {
          trial_user: false
        };
      }
      await this.userRole();
      if (this.roles.length === 1) {
        await this.getRoles();
      }
    } else {
      this.$router.go(-1);
    }
  },
  computed: {
    ...mapState(["roles"])
  },
  methods: {
    ...mapActions([
      "getRoles",
      "getUserRole",
      "deleteUserFunction",
      "updateUser",
      "deleteUserRole",
      "addRole"
    ]),
    async userRole() {
      if (this.user && this.user.user_id) {
        this.loading.fetchRole = true;
        let response = await this.getUserRole(this.user.user_id);
        if (!response.error) {
          this.userAssignedRole = response.data;
        } else {
          this.alert.show = true;
          this.alert.color = "danger";
          this.alert.text = response.error_details.message;
        }
        this.loading.fetchRole = false;
      }
    },

    async removeUserRole(id, index) {
      this.$set(this.loading.deleteRole, index, true);
      this.$forceUpdate();
      let response = await this.deleteUserRole({
        role_id: id,
        user_id: this.user.user_id
      });
      if (!response.error) {
        this.userAssignedRole.splice(index, 1);
      } else {
        this.alert.text = response.error_details.message;
        this.alert.show = true;
        this.alert.color = "danger";
      }
      this.$set(this.loading.deleteRole, index, false);
      this.$forceUpdate();
    },

    editConfirmation() {
      this.showModal = {
        type: "save",
        color: "info",
        size: "sm",
        show: true,
        text: `Are you sure you want to Update <b>${this.user.email}</b>.`,
        title: "Edit User"
      };
    },

    deleteConnfirmation() {
      this.showModal = {
        type: "delete",
        color: "warning",
        size: "sm",
        show: true,
        text: `Are you sure you want to delete <b>${this.user.email}</b>.`,
        title: "Delete User"
      };
    },

    resetPasswordConfirmation() {
      this.showModal = {
        type: "resetpassword",
        color: "warning",
        size: "sm",
        show: true,
        text: `Are you sure you want to reset password for user <b>${this.user.email}</b>.`,
        title: "Update Password"
      };
    },

    okay() {
      if (this.showModal.type === "save") this.confirmEditUser();
      if (this.showModal.type === "delete") this.deleteUser();
      if (this.showModal.type === "resetpassword") this.resetPasswordFunction();
    },

    async confirmEditUser() {
      this.showModal.show = false;
      this.loading.userUpdate = true;
      let response = await this.updateUser({
        id: this.user.user_id,
        data: {
          email: this.user.email,
          name: this.user.name,
          app_metadata: this.user.app_metadata
        }
      });
      if (!response.error) {
        this.alert.text = "User successfully updated";
        this.alert.color = "success";
        this.$router.push("/users");
        this.alert.show = true;
        this.user = {};
      } else {
        this.alert.text = response.error_details.message;
        this.alert.color = "danger";
      }
      this.alert.show = true;
      this.loading.userUpdate = false;
    },

    async setRoles(index) {
      let roleExist = this.userAssignedRole.find(role => {
        return role.id === this.userSelectedRole[index - 1];
      });
      if (!roleExist) {
        this.alertForAddRole.show = false;
        this.$set(this.loading.addRole, index - 1, true);
        this.$forceUpdate();
        let response = await this.addRole({
          id: this.user.user_id,
          roles: [this.userSelectedRole[index - 1]]
        });
        if (!response.error) {
          let role = this.roles.find(obj => {
            return obj.id === this.userSelectedRole[index - 1];
          });
          this.userAssignedRole.push(role);
          this.userSelectedRole[index - 1] = null;
        } else {
          this.alertForAddRole.text = response.error_details.message;
          this.alertForAddRole.color = "danger";
          this.alertForAddRole.show = true;
        }
        this.$set(this.loading.addRole, index - 1, false);
        this.$forceUpdate();
      } else {
        this.alertForAddRole.text = "User already has this role";
        this.alertForAddRole.color = "danger";
        this.alertForAddRole.show = true;
      }
      return;
    },

    async deleteUser() {
      this.showModal.show = false;
      let response = await this.deleteUserFunction(this.user.user_id);
      if (!response.error) {
        this.alert.text = "User successfully deleted.";
        this.alert.color = "success";
        this.$$forceUpdate();
      } else {
        this.alert.text = response.error_details.message;
        this.alert.color = "danger";
      }
      this.alert.show = true;
    },

    async resetPasswordFunction() {
      this.showModal.show = false;
      this.loading.newPassword = true;
      let response = await this.updateUser({
        id: this.user.user_id,
        data: {
          password: this.newPassword,
          connection: "Username-Password-Authentication"
        }
      });
      if (!response.error) {
        this.alert.text = "Password successfully updated";
        this.alert.color = "success";
      } else {
        this.alert.text = response.error_details.message;
        this.alert.color = "danger";
      }
      this.alert.show = true;
      this.loading.newPassword = false;
      this.newPassword = "";
      this.confirmNewPassword = "";
    },

    isPasswordValid() {
      if (this.newPassword.length) {
        return this.newPassword.length >= 7 ? true : false;
      }
    },

    isConfirmNewPasswordMatch(confirmPassword) {
      if (this.newPassword.length && confirmPassword.length)
        return this.newPassword === confirmPassword ? true : false;
    },

    addRoleCount() {
      let vr = this.roles.length - 1 - this.userAssignedRole.length;
      if (
        this.roles.length - 1 !== this.addNumberOfRole &&
        this.addNumberOfRole < vr
      ) {
        this.addNumberOfRole++;
        this.userSelectedRole.push(null);
      }
    },

    showUserModal() {
      this.active = "user";
    },
    showPasswordModal() {
      this.active = "password";
    },
    showUserObjectModal() {
      this.active = "raw";
    }
  }
};
</script>

<style>
.pointer {
  cursor: pointer;
}

.bounce-enter-active {
  animation: bounce-in 0.15s;
}
.bounce-leave-active {
  animation: bounce-in 0.15s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>
